<div class="component-container" #pdfContent>
    <div class="container">
        <div class="logo">
            <div class="logo-text">PRICE<span>MATCHER</span></div>
        </div>

        <div class="success-card">
            <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>

            <h1 *ngIf="receipt">Payment Successful!</h1>
            <p class="success-message" *ngIf="receipt">
                Thank you for your purchase. Your payment has been processed successfully and your subscription is now active.
            </p>

            <div class="order-details">
                <h2 class="section-title">Order Summary</h2>
                
                <div class="detail-row">
                    <div class="detail-label">Order Ref</div>
                    <div class="detail-value">{{ receipt?.ref }}</div>
                </div>
                
                <div class="detail-row">
                    <div class="detail-label">Date</div>
                    <div class="detail-value">{{ receipt?.startDate | date: 'shortDate' }}</div>
                </div>
                
                <div class="detail-row">
                    <div class="detail-label">Plan</div>
                    <div class="detail-value highlight">{{ receipt?.name }} </div>
                </div>
                
                <div class="detail-row">
                    <div class="detail-label">Billing Cycle</div>
                    <div class="detail-value">Monthly</div>
                </div>
                
                <div class="divider"></div>
                
                <div class="detail-row">
                    <div class="detail-label">Subtotal</div>
                    <div class="detail-value">{{ receipt?.summary.total | currency }}</div>
                </div>
                
                <div class="detail-row">
                    <div class="detail-label">Discount</div>
                    <div class="detail-value">-{{ receipt?.summary.discount | currency }}</div>
                </div>
                
                <div class="total-row">
                    <div>Total</div>
                    <div class="detail-value">{{ receipt?.summary.subTotal | currency }}</div>
                </div>
            </div>

            <!--
            <div class="order-details">
                <h2 class="section-title">Payment Information</h2>
                
                <div class="detail-row">
                    <div class="detail-label">Payment Method</div>
                    <div class="detail-value">Visa ending in 4242</div>
                </div>
                
                <div class="detail-row">
                    <div class="detail-label">Payment Status</div>
                    <div class="detail-value success">Paid</div>
                </div>
                
                <div class="detail-row">
                    <div class="detail-label">Next Billing Date</div>
                    <div class="detail-value">May 14, 2024</div>
                </div>
            </div>
            -->

            <div class="button-group">
                <a class="btn btn-outline" (click)="downloadReceipt()" [class.disabled]="emailSent">Download Receipt</a>
                <a [routerLink]="['/settings']" [queryParams]="{ tab: 'billing' }" class="btn btn-primary">Go to Dashboard</a>
            </div>
        </div>
        <!--
        <div class="next-steps">
            <h2 class="section-title">Next Steps</h2>
            
            <ul class="steps-list">
                <li>
                    <div class="step-number">1</div>
                    <div class="step-content">
                        <h3>Set Up Your Profile</h3>
                        <p>Complete your profile information to get the most out of your new subscription.</p>
                    </div>
                </li>
                
                <li>
                    <div class="step-number">2</div>
                    <div class="step-content">
                        <h3>Explore Features</h3>
                        <p>Discover all the premium features now available to you with the Pro plan.</p>
                    </div>
                </li>
                
                <li>
                    <div class="step-number">3</div>
                    <div class="step-content">
                        <h3>Invite Team Members</h3>
                        <p>Add team members to collaborate on projects and maximize productivity.</p>
                    </div>
                </li>
            </ul>
            
            <a [routerLink]="['/']" class="btn btn-success" style="width: 100%;">Get Started Now</a>
        </div>
        -->
        
        <div class="receipt-box">
            <div class="receipt-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
            </div>
            
            <h3 class="receipt-title">Need a Receipt for Your Records?</h3>
            <p class="receipt-description" *ngIf="emailSent">
                A copy of your receipt has been sent to your email. You can also download a PDF copy for your records.
            </p>
            
            <a (click)="emailReceipt()" class="btn btn-outline" [class.disabled]="emailSent">Email PDF Receipt</a>
        </div>
        

        <!--
        <div class="countdown" id="countdown">
            You will be redirected to your dashboard in <span id="timer">10</span> seconds
        </div>
        -->
        <div class="footer">
            <p>If you have any questions, please contact our <a [routerLink]="['/contact']">support team</a></p>
        </div>
    </div>
</div>